const Calculator = ({ ...props }) => (
  <svg
    width={20}
    height={20}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.676 15.625h8.437c.26 0 .469-.21.469-.469V9.531a.469.469 0 0 0-.469-.469H5.676a.469.469 0 0 0-.469.47v5.624c0 .26.21.469.469.469Zm6.094-2.813V10h1.875v4.688H11.77v-1.876ZM8.957 10h1.875v1.875H8.957V10Zm0 2.813h1.875v1.874H8.957v-1.874ZM6.145 10H8.02v1.875H6.145V10Zm0 2.813H8.02v1.874H6.145v-1.874ZM15.05 2.5H4.738c-.75 0-1.406.656-1.406 1.406v12.188c0 .75.656 1.406 1.406 1.406h10.313c.75 0 1.406-.656 1.406-1.406V3.906c0-.75-.656-1.406-1.406-1.406Zm.469 13.594c0 .232-.237.468-.47.468H4.739c-.232 0-.468-.236-.468-.468V8.125h11.25v7.969Zm0-8.907H4.27v-3.28c0-.233.236-.47.468-.47h10.313c.232 0 .469.237.469.47v3.28Z"
      fill="#646464"
    />
  </svg>
)

export default Calculator
